module.exports = __webpack_public_path__ + "img/小跟班.03a4f1ba.jpg";